/* eslint-disable i18next/no-literal-string */

import { useCallback, useEffect, useRef, useState } from 'react';

import { autologin, logout } from '../../services/schibstedAccount';
import { useIdentity } from '../IdentityProvider/IdentityProvider';
import { BrandsIcon, SchibstedIcon } from '../Icon/Icon';

import { setLastShown, shouldAttemptAutologin } from './helpers';

import * as styles from './AutologinPopup.module.scss';

const getRedirectUri = () => {
  const url = new URL(window.location.origin + window.location.pathname);

  url.searchParams.set('utm_source', 'autologin_logout');

  return url.toString();
};

async function tryAutologin() {
  const shouldBeShown = await shouldAttemptAutologin();

  if (shouldBeShown) {
    try {
      await autologin();

      setLastShown(Date.now());
    } catch {}
  }
}

function AutologinPopup() {
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef<HTMLDialogElement>(null!);

  useEffect(() => {
    tryAutologin();
  }, []);

  const { initials, fullName, accountUrl, isLoggedIn } = useIdentity();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('utm_source') === 'autologin') {
      setShowPopup(true);
    }
  }, []);

  const onContinueClick = () => {
    setShowPopup(false);
  };

  const logoutHandler = useCallback(() => {
    logout(getRedirectUri());
  }, []);

  return showPopup && isLoggedIn ? (
    <dialog className={styles.root} ref={popupRef}>
      <div className={styles.title}>
        Du er innlogget med Schibsted-kontoen din
      </div>
      <div className={styles.topRow}>
        <button
          className={styles.button}
          onClick={onContinueClick}
          type="button"
        >
          Ok, jeg forstår
        </button>
        <div className={styles.profile}>
          <div className={styles.avatar}>{initials}</div>
          <div>
            <div>{fullName}</div>
            <button
              className={styles.link}
              onClick={logoutHandler}
              type="button"
            >
              Besøk VGTV uten å være innlogget
            </button>
          </div>
        </div>
      </div>
      <div className={styles.box}>
        <div className={styles.logos}>
          <BrandsIcon />
          <SchibstedIcon />
        </div>
        <p>Din konto brukes på samtlige Schibsted-tjenester.</p>
        <p>
          Les mer om og se innstillinger for din{' '}
          <a
            className={styles.link}
            href={accountUrl}
            rel="noreferrer"
            target="_blank"
          >
            Schibsted-konto
          </a>
        </p>
        <p>
          <a
            className={styles.link}
            href="https://payment.schibsted.no/about/terms?locale=nb_NO"
            rel="noreferrer"
            target="_blank"
          >
            Brukervilkår
          </a>{' '}
          |{' '}
          <a
            className={styles.link}
            href="https://info.privacy.schibsted.com/no/schibsted-norge-personvernerklaering/"
            rel="noreferrer"
            target="_blank"
          >
            Personvernerklæring
          </a>
        </p>
      </div>
    </dialog>
  ) : null;
}

export { AutologinPopup };
